export default "/images/vendor/flag-icon-css/flags/4x3/kz.svg?7194851eb720d3fdb3ad7c94eade695c";